export var raRelationshipsLanguageEnglish = {
    'ra-relationships': {
        duallistinput: {
            select: 'Select',
            unselect: 'Unselect',
            availableItems: 'Available items',
            selectedItems: 'Selected items',
        },
    },
};
